<div class="ion-text-left">
  @if (label) {
    <ion-label [ngClass]="baseCssClass">
      {{ label }}
    </ion-label>
  }

  <ion-item [disabled]="disabled" [ngClass]="{ 'ion-margin-vertical': isMediumOrLarge() }" [lines]="disabled ? 'none' : 'full'">
    @if (icon) {
      <ion-icon [name]="icon" slot="start" color="gray"></ion-icon>
    }
    <ion-textarea
      [ngClass]="baseCssClass"
      [disabled]="disabled"
      value="{{ readOnlyValue }}"
      (ionChange)="onInputChange($event)"
    [placeholder]="getPlaceholderValue()"></ion-textarea>
  </ion-item>
</div>
